import React, {useEffect} from 'react'
import {useAppDispatch, useAppSelector} from '../../store/hooks'
import {setAppView} from '../../store/slices/appViewSlice'
import {AppView} from '../../types'
import {getLogger} from '../../services/logging'
import IbeConfirmation from '../../assets/ibe-booking-complete.png'
import {clearBooking, selectBookingId} from '../../store/slices/bookingSlice'
import {clearCart} from '../../store/slices/shoppingCartSlice'
import {clearSearchParams} from '../../store/slices/searchParamsSlice'
import {clearGuestInfo} from '../../store/slices/guestInfoSlice'
import {clearPayment} from '../../store/slices/paymentSlice'

const logger = getLogger('ConfirmationView')

const ConfirmationView = () => {
  const dispatch = useAppDispatch()
  const bookingId = useAppSelector(selectBookingId)

  const handleBack = () => {
    logger.info({
      message: 'User returning to home page after booking confirmation'
    })

    dispatch(clearBooking())
    dispatch(clearPayment())
    dispatch(setAppView(AppView.HOME))
  }

  useEffect(() => {
    if (bookingId) {
      logger.info({
        message: `Booking confirmed ${bookingId}`
      })

      // clear cart, search params, and guest info
      dispatch(clearCart())
      dispatch(clearSearchParams())
      dispatch(clearGuestInfo())
    }
  }, [bookingId])

  return (
    <div className="flex flex-col gap-2 items-center text-center">
      <img
        src={IbeConfirmation}
        alt="Booking confirmed image."
        className="mx-auto my-12 max-h-72"
      />
      <h1 className="text-2xl font-semibold">Your booking is complete!</h1>
      <h2 className="text-lg">
        Booking Confirmation #:{' '}
        <span className="font-bold text-accent">{bookingId}</span>
      </h2>
      <p>A confirmation email was sent to your email address.</p>
      <a
        className="link link-primary"
        onClick={handleBack}
        onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
          if (e.key === 'Enter') {
            handleBack()
          }
        }}
        tabIndex={0}
        aria-label="Go back to search home page."
      >
        Go Back
      </a>
    </div>
  )
}

export default ConfirmationView
